export const LoadingModeType = { Inline: 'inline', Overlay: 'overlay' } as const;
export type LoadingModeType = (typeof LoadingModeType)[keyof typeof LoadingModeType];

export type LoadingVariantType = 'with-transparent' | 'not-transparent';
